// extracted by mini-css-extract-plugin
export default {"videoBackground":"styles_videoBackground__Gfj2B","videoBackgroundImage":"styles_videoBackgroundImage__lK2sj"};